/**
 * テーマAPI
 * ユーザー設定のAPIクライアント
 */

import axios from 'axios';
import type { UserPreference, UpdateUserPreferenceData } from '../types';

// APIエンドポイント定義
export const themeApi = {
  // 設定取得
  getPreferences: () => 
    axios.get<{ success: boolean; data: UserPreference }>('/v2/user/preferences')
      .then(res => res.data.data),
  
  // 設定更新
  updatePreferences: (data: UpdateUserPreferenceData) => 
    axios.put<{ success: boolean; data: UserPreference; message: string }>(
      '/v2/user/preferences',
      data
    ).then(res => res.data.data),
};